const LIVE_CHANNEL_NAME = "fxhub";
const BROKER_UPDATE_KEY = "fxhub:brokersUpdatedAt";
const BROKER_UPDATE_TYPE = "brokersUpdated";

export function emitBrokerCatalogUpdated() {
  const ts = Date.now();

  try {
    localStorage.setItem(BROKER_UPDATE_KEY, String(ts));
  } catch {
    // ignore
  }

  try {
    const bc = new BroadcastChannel(LIVE_CHANNEL_NAME);
    bc.postMessage({ type: BROKER_UPDATE_TYPE, ts });
    bc.close();
  } catch {
    // ignore
  }
}

export function subscribeBrokerCatalogUpdates(onUpdate: () => void) {
  if (typeof window === "undefined") return () => undefined;

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== BROKER_UPDATE_KEY) return;
    onUpdate();
  };

  let bc: BroadcastChannel | null = null;
  const handleBroadcast = (event: MessageEvent) => {
    if (event.data?.type !== BROKER_UPDATE_TYPE) return;
    onUpdate();
  };

  window.addEventListener("storage", handleStorage);

  try {
    bc = new BroadcastChannel(LIVE_CHANNEL_NAME);
    bc.addEventListener("message", handleBroadcast);
  } catch {
    bc = null;
  }

  return () => {
    window.removeEventListener("storage", handleStorage);
    if (bc) {
      bc.removeEventListener("message", handleBroadcast);
      bc.close();
    }
  };
}
